import React, { Fragment, useContext, useEffect, useState } from "react";
import SignaturePad from "signature_pad";

// Provider
import { AppContext, SocketCommand, socketManager } from "../../../components/AppProvider";

// Utils
import { AlertLayer } from "../../../components/UI/Dialog";
import { PostApi1601, PostApi1606, ReverseGc } from "../../../modules/network/padoPost";
import { _O } from "../../../modules/utils";
import { setCookie } from "../../../modules/utils/cookie";
import { mapLayer, MapView } from "../../common/Modal/NaverMap";
import { closeLayerFn, Container, openLayerFn } from "../../Layout";
import { requestHsptList } from "../../Reservation/Surround";

import { stringToTelNo } from "../../../modules/utils/CheckLogic";
import { requestGetNewPoint } from "../../../modules/utils/getNewPoint";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { userHabit } from "../../../modules/utils/UserHabit";
import _icon_reset from "../../../resources/images/icon/icon_arrow_circle.png";
import _icon_video_file from "../../../resources/images/icon/icon_hospital_location.png";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import { TermsLayerPopup } from "../../Company/TermsDetail/TermsPopup";
import { SubMenu, SUBS } from "../Pmr";
import { checkMsgCount } from "../PmrLayout";
import { GetGpsInfo } from "../../../modules/utils/GetGpsInfo";
import useTitle from "./../../../modules/hooks/useTitle";

let sigPad = null;

export default () => {
  useTitle("개인진료기록_제증명_신청");
  const sub = SUBS[3];
  const [selectHpNm, setSelectHpNm] = useState("");
  const [hpLat, setHpLat] = useState("");
  const [hpLon, setHpLon] = useState("");

  const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);
  const [list, setList] = useState();
  const [area, setArea] = useState("");

  const [signString, setSignString] = useState(null);

  const [hsptCd, setHsptCd] = useState();
  const [hsptTypeCd, setHsptTypeCd] = useState();
  const [aplnRsnCd, setAplnRsnCd] = useState();
  const [docTypeCd, setDocTypeCd] = useState();
  const [docTypeNm, setDocTypeNm] = useState();
  const [docPrice, setDocPrice] = useState();
  const [rqstRelCd, setRqstRelCd] = useState("PRCP");

  const [locationInfo, setLocationInfo] = useState({});
  const [myLocation, setMyLocation] = useState();

  const [paperList, setPaperList] = useState();
  const [isSigned, setIsSigned] = useState(true);
  const [defaultSign, setDefaultSign] = useState(true);

  // 병원별 진료과 리스트
  const [hsptTypeList, setHsptTypeList] = useState();

  // msgCount
  const [msgCount, setMsgCount] = useState("");

  const agreement = () => {
    // 빈값 체크
    if (!selectHpNm || selectHpNm === "") {
      handleAlert("제증명서류 신청실패", "병원을 선택하세요.");
      return;
    }

    if (!docTypeCd || docTypeCd === "") {
      handleAlert("제증명서류 신청실패", "신청서류를 선택하세요.");
      return;
    }

    if (!aplnRsnCd || aplnRsnCd === "") {
      handleAlert("제증명서류 신청실패", "서류신청목적을 선택하세요.");
      return;
    }

    if (isSigned === false) {
      handleAlert("제증명서류 신청실패", "서명정보가 필요합니다.");
      return;
    }

    if (!document.getElementById("psnlInfoAgreeYn").checked) {
      handleAlert(
        "제증명서류 신청실패",
        "개인정보수집 / 진료기록 열람동의 및 작성 동의를 해주십시오."
      );
      return;
    }

    request1601(
      $(".fs2").val(),
      userinfo.userName,
      userinfo.birth + userinfo.sex,
      userinfo.userPhone
    );
    resetOption();
  };

  const request1601 = (rqstDesc, rqstNm, rqstNum, rqstTelNo) => {
    PostApi1601(
      userinfo,
      cfg,
      phonecfg,
      hsptCd,
      hsptTypeCd,
      aplnRsnCd,
      rqstDesc,
      rqstRelCd,
      rqstNm,
      rqstNum,
      rqstTelNo,
      "Y",
      sigPad.toDataURL(),
      docTypeCd,
      docTypeNm,
      docPrice
    )
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          _O.Open("/pmr/proof/pay/" + res.seqNo);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1603 = (userinfo, srchHsptNm) => {
    requestHsptList(userinfo, cfg, phonecfg, "Y", srchHsptNm, setList);
  };

  const request1606 = hsptCd => {
    PostApi1606(userinfo, cfg, phonecfg, hsptCd)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setPaperList(res.result);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  // resultList 분할
  const sortResultList = resultList => {
    for (let i = 0; i <= resultList.length; i++) {
      if (resultList[i].addAmt != 0) {
        // 추가요금이 붙는 문서
      } else {
        // 일반문서 추가요금X
      }
    }
  };

  const searchHpList = () => {
    request1603(userinfo, $("#srchHsptNm").val());
  };

  const resetOption = () => {
    // $(".open-medical-layer").text('진료과를 선택하세요.');
    $(".open-document-layer").text("필요서류를 선택하세요.");
    $(".open-purpose-layer").text("신청목적을 선택하세요.");

    $(".fs2").val("");

    setHsptCd("");
    setHsptTypeCd("");
    setAplnRsnCd("");
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const openTermsLayer = () => {
    openLayerFn($("#termsPopup"));
    // setTimeout(()=>{
    window.scrollTo(0, 0);
    // }, 100)
  };

  // 최근받은파일함 표시
  useEffect(() => {
    checkMsgCount(
      userinfo,
      cfg,
      phonecfg,
      "9",
      "00000000",
      "99999999",
      setMsgCount
    );
    // socketManager(SocketCommand.GET_GPS_INFO, undefined);
    if (phonecfg.phoneOS === "ANDROID") {
      if (parseInt(phonecfg.version.split(".")[2]) > 81) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    } else if (phonecfg.phoneOS === "IOS") {
      if (parseInt(phonecfg.version.split(".")[2]) > 35) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    }
  }, []);

  // 병원검색로직추가
  // let userinfo2 = reLogin(auth, userinfo, dispatch);
  useEffect(() => {
    request1603(userinfo);
  }, []);

  useEffect(() => {
    $(".map-view-layer .btn-closex").click(function () {
      closeLayerFn($(".map-view-layer"));
    });
  }, []);

  useEffect(() => {
    request1606(hsptCd);
  }, [hsptCd]);

  useEffect(() => {
    $(".open-hosp-layer").click(function () {
      openLayerFn($(".pupl-bot-layercontain.hosp-layer"));
      // 무언가 처리가 필요
    });

    $(".open-medical-layer").click(function () {
      openLayerFn($(".pupl-bot-layercontain.medical-layer"));
    });

    $(".open-document-layer").click(function () {
      if ($(".open-hosp-layer").text() != "병원을 선택하세요.") {
        openLayerFn($(".pupl-bot-layercontain.document-layer"));
      } else {
        handleAlert("", "병원을 먼저 선택하세요.");
      }
    });

    $(".open-purpose-layer").click(function () {
      openLayerFn($(".pupl-bot-layercontain.purpose-layer"));
    });

    $(".open-person-ch-layer").click(function () {
      // 옵션 초기화 로직 추가
      $(".pp-scroll-box.stepsbox > div").hide();
      $(".pp-scroll-box.stepsbox > div").eq(0).show();

      $("input:radio[name='radio04']").prop("checked", false);
      $(".pp-agree-check").prop("checked", false);

      openLayerFn($(".pupl-bot-layercontain.person-ch-layer"));
    });

    //닫기(공통)
    $(".pupl-bot-layercontain a.btn-pp-close").click(function () {
      closeLayerFn($(".pupl-bot-layercontain"));
    });
  }, []);

  useEffect(() => {
    userHabit(phonecfg, "PF021");
    NativeAction(phonecfg, "statusColor", "#b2bee6");
  }, [phonecfg.version]);

  useEffect(() => {
    setCookie("introAge", true, 21);

    ReverseGc(cfg, phonecfg.userLng + "," + phonecfg.userLat)
      .then(res => {
        let region = res.results[0].region;
        let land = res.results[0].land;

        let locationNow =
          region.area1.name +
          " " +
          region.area2.name +
          " " +
          land.name +
          " " +
          land.number1;

        setMyLocation(locationNow);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);
  }, []);
  return (
    <Fragment>
      <ScrollToTop />
      <Container
        Title="제증명서류"
        msgCount={msgCount}
        goToUrl="/"
        proof="APPLY"
        color="purple"
        onClick={() => agreement()}>
        <div className="contents sub priv">
          {/* subTabMenu */}
          <SubMenu code={sub.code} sub={SUBS} />
          {/* /subTabMenu */}
          {/* <SubMenu code="APPLY" sub={SUBSUBS} /> */}

          <div className="sub-contents">
            <div className="steps-bar-area">
              <ul>
                <li className="on" style={{ width: "50%" }}>
                  <a
                    style={{
                      height: "55px",
                      lineHeight: "55px",
                      fontSize: "15px",
                      fontWeight: "bold",
                    }}
                    onClick={() => _O.OpenMenu("/pmr/proofRecipt")}>
                    제증명 신청
                  </a>
                </li>
                <li style={{ width: "50%" }}>
                  <a
                    style={{
                      height: "55px",
                      lineHeight: "55px",
                      fontSize: "15px",
                      fontWeight: "bold",
                    }}
                    onClick={() => _O.OpenMenu("/pmr/proofList/3/1/1")}>
                    제증명 보관함
                  </a>
                </li>
                {/* <li><a>STEP 4</a></li> */}
              </ul>
            </div>
            <div className="steps-bar-area">
              <ul>
                <li className="on" style={{ width: "33%" }}>
                  <a>STEP 1</a>
                </li>
                <li style={{ width: "33%" }}>
                  <a>STEP 2</a>
                </li>
                <li style={{ width: "34%" }}>
                  <a>STEP 3</a>
                </li>
              </ul>
            </div>

            <div className="sub-title">1. 인적사항</div>
            <div className="insection-list">
              <ul>
                <li>
                  <div className="tit">이름</div>
                  <div>{userinfo.userName}</div>
                </li>
                <li>
                  <div className="tit">주민등록번호</div>
                  <div>
                    {userinfo.birth.substring(2, 8)}-{userinfo.sex}******
                  </div>
                </li>
                <li>
                  <div className="tit">핸드폰 번호</div>
                  <div>
                    {userinfo.userPhone.substring(0, 3)}-
                    {userinfo.userPhone.substring(3, 7)}-
                    {userinfo.userPhone.substring(7, 11)}
                  </div>
                </li>
              </ul>
            </div>

            <div className="sub-title">2. 병원정보를 입력해 주세요. </div>
            <div className="device-state-info res">
              제증명서류 신청이 필요한 병원정보를 입력하면 됩니다.
            </div>

            <div className="insection-list">
              <ul>
                <li>
                  <div className="tit">병원이름</div>
                  <div>
                    <a className="btn-select-downbox open-hosp-layer">
                      병원을 선택하세요.
                    </a>
                  </div>
                </li>
                <li>
                  <div className="tit">신청서류</div>
                  <div>
                    <a className="btn-select-downbox open-document-layer">
                      필요서류를 선택하세요.
                    </a>
                  </div>
                </li>
                <li>
                  <div className="tit">서류신청 목적</div>
                  <div>
                    <a className="btn-select-downbox open-purpose-layer">
                      신청목적을 선택하세요.
                    </a>
                  </div>
                </li>
                <li>
                  <div className="tit">요청사항(선택)</div>
                  <div>
                    <input
                      type="text"
                      className="textbox fs2"
                      placeholder="기타 요청사항을 작성해 주세요."
                    />
                  </div>
                </li>
              </ul>
            </div>

            <div className="sub-title">3. 신청자 서명</div>
            <div className="device-state-info bmag2">
              한번등록한 인적사항은 자동 저장됩니다.
            </div>
            <label className="check-box">
              <input type="checkbox" id="psnlInfoAgreeYn" defaultChecked />{" "}
              <i></i>
            </label>
            <span
              onClick={() => openTermsLayer()}
              style={{ textDecoration: "underline", color: "blue" }}>
              개인정보수집 / 진료기록 열람동의 및 작성 동의{" "}
            </span>

            <CanvasArea
              isSigned={isSigned}
              setIsSigned={setIsSigned}
              defaultSign={defaultSign}
              setDefaultSign={setDefaultSign}
            />
          </div>
        </div>
      </Container>

      <BottomLayer
        setSelectHpNm={setSelectHpNm}
        list={list}
        setHpLat={setHpLat}
        setHpLon={setHpLon}
        searchHpList={() => searchHpList()}
        setArea={setArea}
        setHsptCd={setHsptCd}
        setHsptTypeList={setHsptTypeList}
        resetOption={resetOption}
        setLocationInfo={setLocationInfo}
        myLocation={myLocation}
      />
      <MedicalSubject
        setHsptTypeCd={setHsptTypeCd}
        hsptTypeList={hsptTypeList}
      />
      <PaperSelect
        setDocTypeCd={setDocTypeCd}
        setDocTypeNm={setDocTypeNm}
        setDocPrice={setDocPrice}
        paperList={paperList}
      />
      <PurposeLayer setAplnRsnCd={setAplnRsnCd} />
      <ProposerLayer />
      <PrivAlert />
      <MapView
        selectHpNm={selectHpNm}
        hpLat={hpLat}
        hpLon={hpLon}
        locationInfo={locationInfo}
        popupType="PF"
      />
      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        priv="priv"
        // handleConfirmCB={handleAlertCB}
      />
      <TermsLayerPopup />
    </Fragment>
  );
};

export const SUBSUBS = [
    { url: "/pmr/proofRecipt", code: "APPLY", label: "제증명신청" },
    { url: "/pmr/proofList/3/1/1", code: "STORAGE", label: "제증명보관함" },
    // { url: "/proof/history", code: "HISTORY", label: "보험청구이력" },
];

export const BottomLayer = (props) => {
    const { setSelectHpNm, list, setHpLat, setHpLon, searchHpList, setArea, setHsptCd, setHsptTypeList, resetOption, setLocationInfo, myLocation } = props;

    useEffect(() => {
        $("#srchHsptNm").bind('keydown', function(e) {
            if(e.keyCode === 13) {
                searchHpList();
            }
        })
    }, [])

    return (
      <div className="pupl-bot-layercontain hosp-layer">
        <div className="pbl-blind"></div>
        <div
          className="in-p-layer vrhalf"
          style={{
            borderTopLeftRadius: "60px",
            borderTopRightRadius: "60px",
            padding: "70px 0px 0px",
          }}
        >
          <a
            className="btn-pp-close"
            style={{
              right: "8px",
            }}
          />
          <div className="pp-scroll-box">
            <div className="pp-in-cont">
              <div
                style={{
                  margin: "5px 20px 0px",
                }}
              >
                <div className="search">
                  {/* <a onClick={searchHpList}
                                    style={{
                                        width:"42px",
                                        height:"42px",
                                        left: "0px"
                                    }}
                                /> */}
                  {/* <input type="text" id="srchHsptNm" className="textbox fs2" placeholder="병원이름을 입력해 주세요." 
                                    style={{
                                        paddingLeft:"42px"
                                    }}
                                /> */}

                  <div>
                    {/* <label
                                        style={{
                                            width:"30px",
                                            height:"30px",
                                            position:"absolute"
                                        }}
                                    >
                                        <i className="location-w" />
                                    </label> */}
                    {/* <p
                                        style={{
                                            fontFamily:"'Noto Sans KR', sans-serif",
                                            fontSize:"15px",
                                            color:"#fff",
                                            textAlign:"center"
                                        }}
                                    >
                                        내 위치: {myLocation ? myLocation : '지금 위치를 측정할 수 없습니다.'}
                                    </p>

                                    <p
                                        style={{
                                            fontFamily:"'Noto Sans KR', sans-serif",
                                            fontSize:"14px",
                                            color:"#fff",
                                            textAlign:"right"
                                        }}
                                    >
                                        가까운 병원 순
                                    </p> */}

                    <p
                      style={{
                        fontFamily: "'Noto Sans KR', sans-serif",
                        fontSize: "15px",
                        color: "#fff",
                        textAlign: "left",
                      }}
                    >
                      자주가는 병원목록
                      <label>
                        <input
                          type="button"
                          value="연동병원추가+"
                          style={{
                            position: "absolute",
                            display: "block",
                            top: "58%",
                            marginTop: "-14px",
                            background: "#fff",
                            color: "#6A62E6",
                            border: "1px solid #6A62E6",
                            right: "0px",
                            width: "100px",
                            height: "28px",
                            borderRadius: "5px",
                          }}
                          // onClick={() => _O.Open("/mp/settings/data/hspt/proof")}
                          onClick={() => _O.Open("/cnntHspt/1/proof")}
                        />
                      </label>
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="wbox-select-list">
                  {/* 추후 컴포넌트화 */}
                  {list && list.length > 0 ? (
                    list.map((m, i) => (
                      // <Hospital
                      //     key={"hospitalList"+i}

                      //     setSelectHpNm={setSelectHpNm}
                      //     setHpLat={setHpLat}
                      //     setHpLon={setHpLon}
                      //     setHsptCd={setHsptCd}
                      //     hsptCd={m.hsptCd}
                      //     hsptNm={m.hsptNm}
                      //     hsptTypeList={m.hsptTypeList}
                      //     setHsptTypeList={setHsptTypeList}
                      //     resetOption={resetOption}

                      //     hsptDstnc={m.hsptDstnc}
                      //     locationInfo={m}
                      //     setLocationInfo={setLocationInfo}
                      // />

                      <Hospital2
                        m={m}
                        key={"HSPT" + i}
                        resetOption={resetOption}
                        setHsptCd={setHsptCd}
                        setHsptTypeList={setHsptTypeList}
                        setSelectHpNm={setSelectHpNm}
                        setHpLat={setHpLat}
                        setHpLon={setHpLon}
                        setLocationInfo={setLocationInfo}
                      />
                    ))
                  ) : (
                    <Nothing type="HSPT" />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export const Hospital = props => {
  const {
    setSelectHpNm,
    setHpLat,
    setHpLon,
    setHsptCd,
    hsptCd,
    hsptNm,
    hsptTypeList,
    setHsptTypeList,
    resetOption,
    hsptDstnc,
    locationInfo,
    setLocationInfo,
  } = props;
  const { phonecfg } = useContext(AppContext);

  const clickHpList = (hsptCd, hsptNm) => {
    resetOption();
    setHsptCd(hsptCd);
    setHsptTypeList(hsptTypeList);
    setSelectHpNm(hsptNm);

    $(".open-hosp-layer").text(hsptNm);

    closeLayerFn($(".pupl-bot-layercontain.hosp-layer"));
  };

  // const mapLayer = (hpNm, lat, lon) => {
  //     openLayerFn($(".map-view-layer"));

  //     setSelectHpNm(hpNm);
  //     setHpLat(lat);
  //     setHpLon(lon);
  //     setLocationInfo(locationInfo);
  // };

  return (
    <div
      onClick={() => clickHpList(hsptCd, hsptNm)}
      style={{
        margin: "0px 20px 10px",
      }}>
      <label>
        <input
          type="button"
          value="상세보기"
          onClick={() => mapLayer(phonecfg, setLocationInfo, locationInfo)}
          style={{
            position: "absolute",
            display: "block",
            top: "50%",
            marginTop: "-14px",
            background: "#b2bee5",
            color: "#fff",
            border: "0px",
            right: "10px",
            width: "70px",
            height: "28px",
            borderRadius: "5px",
          }}
        />
      </label>
      <label
        style={{
          left: "-16px",
          // top:"-20px",
          top: "-50%",
          marginTop: "6px",
        }}>
        <input type="radio" name="radio01" />
        <i></i>
      </label>
      <div className="inbox">
        <b>{hsptNm}</b>
        {hsptDstnc > 0 && (
          <p>
            <span>내 위치에서 {hsptDstnc}km</span>
          </p>
        )}
      </div>
    </div>
  );
};

export const Hospital2 = props => {
  const {
    m,
    resetOption,
    setHsptCd,
    setHsptTypeList,
    setSelectHpNm,
    setHpLat,
    setHpLon,
    setLocationInfo,
  } = props;
  const { phonecfg } = useContext(AppContext);

  const clickHpList = (hsptCd, hsptNm) => {
    resetOption();
    setHsptCd(hsptCd);
    setHsptTypeList(m.hsptTypeList);
    setSelectHpNm(hsptNm);

    $(".open-hosp-layer").text(hsptNm);

    closeLayerFn($(".pupl-bot-layercontain.hosp-layer"));
  };

  return (
    <div className="addr" style={{ padding: "0px 20px 15px" }}>
      {/* 병원정보영역 */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "15px",
        }}>
        <div style={{ width: "82%" }}>
          <b>
            {m.hsptNm}({m.address2})
            {m.profUseYn === "N" && <font color="red">[신청불가]</font>}
            <a
              className="location_icon"
              style={{ top: "11px" }}
              onClick={() => mapLayer(phonecfg, setLocationInfo, m)}></a>
          </b>
          <p>
            {m.address3} {m.address4}
          </p>
          {/* <p>Tel : {m.phone.toString().replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3")}</p> */}
          <p>
            {/* {m.phone.toString().replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3")} */}
            {stringToTelNo(m.phone)}
            <span style={{ color: "#939fcc" }}> 현재위치 {m.distance}km</span>
          </p>
        </div>
        {/* 병원정보영역 */}

        {/* 체크박스 영역 */}
        {m.profUseYn === "Y" && (
          <label
            style={{
              position: "absolute",
              width: "40px",
              height: "40px",
              right: "5vw",
              top: "50%",
              transform: "translateY(-50%)",
            }}
            onClick={() => clickHpList(m.hsptCd, m.hsptNm)}>
            <input type="button" style={{ display: "none" }} />
            <i
              className="styleCheckI"
              style={{ width: "40px", height: "40px", top: "28%" }}></i>
          </label>
        )}

        {/* 체크박스 영역 */}
      </div>
    </div>
  );
};

export const MedicalSubject = (props) => {
    const {setHsptTypeCd, hsptTypeList} = props;

    const selectSubject = (name, code) => {
        $(".open-medical-layer").text(name);
        setHsptTypeCd(code);
        closeLayerFn($('.pupl-bot-layercontain.medical-layer'));
    }

    return (
        <div className="pupl-bot-layercontain medical-layer">
            <div className="pbl-blind"></div>
            <div className="in-p-layer">
                <a className="btn-pp-close"></a>
                <div className="pp-scroll-box">
                    <div className="pp-in-cont">
                        <div>
                            <div className="wbox-select-list">
                                {hsptTypeList && hsptTypeList != ""
                                    ? hsptTypeList.map((m, i) => (
                                        <div key={"mdcSbj"+i} >
                                            <label><input type="radio" name="radio02" /><i></i></label>
                                            <div className="inbox" onClick={()=>selectSubject(m.hsptTypeNm, m.hsptTypeCd)}>
                                                {m.hsptTypeNm}
                                            </div>
                                        </div>
                                    ))
                                    : <Nothing type="HSPTTYPE" />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
} 

export const PaperSelect = (props) => {
    const {setDocTypeCd, setDocTypeNm, setDocPrice, paperList} = props;

    const selectPaperList = () => {
        let chk_arr = [];
        let chk_arr_text = [];
        let chk_arr_price =[];
        let chk_arr2;
        let chk_arr_text2;
        let chk_arr_price2;
        
        $("input[name=paperList]:checked").each(function() {
            let chk = $(this).val();
            
            chk_arr.push(chk.split("/")[0]);
            chk_arr_text.push(chk.split("/")[1]);
            chk_arr_price.push(chk.split("/")[2]);

            if(!chk_arr2) {
                chk_arr2 = chk.split("/")[0];
                chk_arr_text2 = chk.split("/")[1];
                chk_arr_price2 = chk.split("/")[2];
            } else {
                chk_arr2 += "^" + chk.split("/")[0];
                chk_arr_text2 += "^" + chk.split("/")[1];
                chk_arr_price2 += "^" + chk.split("/")[2];
            }
            
        });

        if(chk_arr.length > 0) {
            // setDocTypeCd(chk_arr);
            // setDocPrice(chk_arr_price);
            setDocTypeCd(chk_arr2);
            setDocPrice(chk_arr_price2);
            setDocTypeNm(chk_arr_text2);
        }
        closeLayerFn($(".pupl-bot-layercontain.document-layer"));

        if(chk_arr_text.length > 1) {
            $(".open-document-layer").text(chk_arr_text[0] + " 외 " + (chk_arr_text.length-1));
        } else if(chk_arr_text.length = 1) {
            if(chk_arr_text[0]) {
                $(".open-document-layer").text(chk_arr_text[0]);
            } else {
                $(".open-document-layer").text("필요서류를 선택하세요.");
            }
        } else {
            $(".open-document-layer").text("필요서류를 선택하세요.");
        }
    }

    return (
        <div className="pupl-bot-layercontain document-layer">
            <div className="pbl-blind"></div>
            <div className="in-p-layer vertm">
                {/* <a className="btn-pp-close"></a> */}
                <div className="pp-scroll-box">
                    <div className="pp-in-cont">

                        {paperList && paperList != ""
                            // ?   <div style={{maxHeight:"300px", overflow:"auto"}}>
                            ?   <div style={{maxHeight:"300px", overflow:"auto"}}>
                                    <div className="wbox-select-list">
                                        <div className="device-state-info res" style={{padding:"0px 15px", backgroundColor:"#d6d6d6", textAlign:"left", color:"#000", fontSize:"14px"}}>
                                            일반문서
                                        </div>
                                        {paperList && paperList != ""
                                            && paperList.map((m, i) => (
                                                <Fragment>
                                                    {m.addAmt === 0 &&
                                                        <div key={"cdRmk1_" + i}>
                                                            <label><input type="checkbox" name='paperList' value={m.docTypeCd+"/"+m.docTypeNm+"/"+m.prodPrice.replace(',', '')} /><i></i></label>
                                                            <div className="inbox">
                                                                {m.docTypeNm} ({m.prodPrice}원)
                                                            </div>
                                                        </div>
                                                    }
                                                </Fragment>
                                            ))
                                        }

                                        <div className="device-state-info res" style={{padding:"0px 15px", backgroundColor:"#d6d6d6", textAlign:"left", color:"#000", fontSize:"14px"}}>
                                            추가금액문서(n장 초과시 장당 금액추가)
                                        </div>
                                        {paperList && paperList != ""
                                            && paperList.map((m, i) => (
                                                <Fragment>
                                                    {m.addAmt != 0 &&
                                                        <div key={"cdRmk2_" + i}>
                                                            <label><input type="checkbox" name='paperList' value={m.docTypeCd+"/"+m.docTypeNm+"/"+m.prodPrice.replace(',', '')} /><i></i></label>
                                                            <div className="inbox">
                                                                {m.docTypeNm} ({m.prodPrice}원) 
                                                                <br />
                                                                ({m.stdVal}장 초과시 장당 {m.addAmt}원 추가)
                                                            </div>
                                                        </div>
                                                    }
                                                </Fragment>
                                            ))
                                        }

                                    </div>

                                    <div className="in-list-title"></div>
                                    {/* <div className="wbox-select-list">
                                        <div className="inbox" style={{textAlign:"center", padding:"15px 50px 15px 50px"}} onClick={()=>selectPaperList()}>
                                            확인
                                        </div>
                                    </div> */}
                                </div>
                            : <Nothing type="DOC" />
                        }
                        <div className="wbox-select-list">
                            <div className="inbox" style={{textAlign:"center", padding:"15px 50px 15px 50px"}} onClick={()=>selectPaperList()}>
                                확인
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const PurposeLayer = (props) => {
    const {setAplnRsnCd} = props;

    const selectPurposeList = (param, name) => {
        setAplnRsnCd(param);
        $(".open-purpose-layer").text(name);
        closeLayerFn($(".pupl-bot-layercontain.purpose-layer"));
    }
    return (
        <div className="pupl-bot-layercontain purpose-layer">
            <div className="pbl-blind"></div>
            <div className="in-p-layer">
                <a className="btn-pp-close"></a>
                <div className="pp-scroll-box">
                    <div className="pp-in-cont">
                        <div>
                            <div className="wbox-select-list">
                                <div>
                                    <label><input type="radio" name="radio03" onClick={()=>selectPurposeList('01', '보험청구')} /><i></i></label>
                                    <div className="inbox">
                                        보험청구
                                    </div>
                                </div>

                                <div>
                                    <label><input type="radio" name="radio03" onClick={()=>selectPurposeList('02', '회사')}/><i></i></label>
                                    <div className="inbox">
                                        회사
                                    </div>
                                </div>

                                <div>
                                    <label><input type="radio" name="radio03" onClick={()=>selectPurposeList('03', '학교')}/><i></i></label>
                                    <div className="inbox">
                                        학교
                                    </div>
                                </div>

                                <div>
                                    <label><input type="radio" name="radio03" onClick={()=>selectPurposeList('04', '경찰서')}/><i></i></label>
                                    <div className="inbox">
                                        경찰서
                                    </div>
                                </div>

                                <div>
                                    <label><input type="radio" name="radio03" onClick={()=>selectPurposeList('05', '관공서')}/><i></i></label>
                                    <div className="inbox">
                                        관공서
                                    </div>
                                </div>

                                <div>
                                    <label><input type="radio" name="radio03" onClick={()=>selectPurposeList('09', '기타')}/><i></i></label>
                                    <div className="inbox">
                                        기타
                                    </div>
                                </div>					
            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const ProposerLayer = () => {
    const { userinfo } = useContext(AppContext);

    useEffect(()=> {
        ////본인 , 가족 신청 구분
        $(".btn-check01 a.btn-next").click(function(){
            if( $(".ra-check01.num1").is(":checked") ) {
                closeLayerFn($(".pupl-bot-layercontain")); //본인일 경우 : 닫힌 후 자동입력 

                // 이름
                $("#proposeName").val(userinfo.userName);
                // 핸드폰번호
                // $("#proposeNum1").val();
                $("#proposeNum2").val(userinfo.userPhone.substring(3,7));
                $("#proposeNum3").val(userinfo.userPhone.substring(7,11));

            } else if( $(".ra-check01.num2").is(":checked") ) { //대리신청인 경우 다음 스텝
                $(".pp-scroll-box.stepsbox > div").hide();
                $(".pp-scroll-box.stepsbox > div").eq(1).show();
            }
        });

        /// 두번째 스텝에서 이전으로 가기 버튼
        $(".btn-before-step").click(function(){
            $(".pp-scroll-box.stepsbox > div").hide();
            $(".pp-scroll-box.stepsbox > div").eq(0).show();
        });

        /// 두번째 스텝에서 다음(첨부파일 등록스텝)으로 가기
        $(".btn-thr-stepgo").click(function(){
            if($(".pp-agree-check").is(":checked")){
                $(".pp-scroll-box.stepsbox > div").hide();
                $(".pp-scroll-box.stepsbox > div").eq(2).show();
            }else{
                $(".priv-alert-layer").show();  //개인정보수집 ~~ 동의해주세요.
            }
        });
    }, [])
    return (
        <div className="pupl-bot-layercontain person-ch-layer">
            <div className="pbl-blind"></div>
            <div className="in-p-layer">
                <a className="btn-pp-close"></a>
                <div className="pp-scroll-box stepsbox">
                    
                    <div className="pp-in-cont">
                        <div>
                            <div className="wbox-select-list">
                                <div>
                                    <label><input type="radio" name="radio04" className="ra-check01 num1"  /><i></i></label>
                                    <div className="inbox he2">
                                        본인이 신청하겠습니다.
                                    </div>
                                </div>

                                <div>
                                    <label><input type="radio" name="radio04" className="ra-check01 num2" /><i></i></label>
                                    <div className="inbox">
                                        가족이 대리신청 하겠습니다.<br/>
                                        <em className="gray fs">(신분증과 가족관계증명서를 준비해 주세요.)</em>
                                    </div>
                                </div>
                            </div>

                            <div className="pp-btns-area btn-check01">
                                <a className="btn-cancel-layer">취소</a>
                                <a className="btn-next">다음</a>
                            </div>
                        </div>
                    </div>

                    <div className="pp-in-cont">
                        <div>
                            <div className="ppin-half-box">
                                <div>
                                    <div className="in-list-title">신청자 신분증(앞면)</div>
                                    <div className="btn-box-plus">
                                        <a className="btn-thr-stepgo"></a>
                                    </div>
                                </div>
                                <div>
                                    <div className="in-list-title">가족관계증명서</div>
                                    <div className="btn-box-plus">
                                        <a className="btn-thr-stepgo"></a>
                                    </div>
                                </div>
                            </div>					
                        </div>
                        <div>
                            <div>
                                <label className="pp-agree">
                                    개인정보수집 / 진료기록 알람 동의 및 작성 동의
                                    <input type="checkbox" className="pp-agree-check" /><i></i>
                                </label>
                            </div>
                            <div>
                                <div className="pp-btns-area">
                                    <a className="btn-before-step">이전</a>
                                    <a className="btn-thr-stepgo">다음</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="pp-in-cont">
                        <div>
                            <div className="in-list-title">파일첨부 방법을 선택해 주세요.</div>
                            <div className="full-btns-box">
                                <a>사진앨범</a>
                                <a>카메라</a>
                                <a className="btn-cancel-layer">취소</a>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

export const PrivAlert = () => {
    useEffect(()=>{
        //개인정보수집 ~~ 동의해주세요.  레이어 닫기
        $(".priv-alert-layer .tbns-area a").click(function(){
            $(".priv-alert-layer").hide();
        });
    }, []);
    return (
        <div className="blacklayer-container priv-alert-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical priv">
                        <div className="blgr-title">확인</div>
                        
                        <div className="save-question-box">
                            개인정보수집 및 진료기록 열람에<br/>
                            동의해주세요
                        </div>

                        <div className="tbns-area">
                            <a className="btn-round gray">취소</a>
                            <a className="btn-round wht">확인</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const CanvasArea = (props) => {
    // const {setSignString} = props; 
    const {isSigned, setIsSigned, defaultSign, setDefaultSign} = props; 
    const { userinfo } = useContext(AppContext);

    const signEvent = () => {
        
        sigPad = new SignaturePad(document.getElementById('signCanvas'), {
            onBegin: () => {
                if(defaultSign) {
                    // sigPad.clear();
                    sigPad.isEmpty();
                    setDefaultSign(false);
                }
                if(isSigned === false) {
                    sigPad.isEmpty();
                    setIsSigned(true);
                }
            }
        });

    }

    useEffect(() => {
        // 최초
        signEvent();

        if(!isSigned) {
            drawText("서명을 하십시오.", "P");
        }
    }, [isSigned, defaultSign]);

    useEffect(() => {
        drawText(userinfo.userName, "S");
    }, []);

    const handleRestSignature = () => {
        sigPad.clear();
        setIsSigned(false);
        // drawText("서명을 하십시오.", "P");
    };

    return (
        <div className="sign-box-area" style={{marginBottom:"40px", background:'#efefef'}}>
            <canvas
                id="signCanvas"
                className='signature-pad'
                // height={'100'}
            />
            <button onClick={()=>handleRestSignature()} style={{position:'absolute', float:'right', bottom:'0', right:'10px'}}>
                <img src={_icon_reset} alt=""  style={{width:'15px'}}/>
            </button>
        </div>
    );
}

function drawText(text, type) {
    var ctx = document.getElementById('signCanvas').getContext('2d');
    // ctx.strokeText('홍 길 동', 10, 50);
    if(type === "P") {
        ctx.fillStyle = 'gray'
        ctx.font = '20pt BM YEONSUNG OTF';
        ctx.fillText(text , 55, 85);
    } else {
        ctx.font = '40pt BM YEONSUNG OTF';
        ctx.textAlign = 'center';
        // ctx.fillText(text , 65, 90);
        ctx.fillText(text , 150, 90);
        // ctx.fillText(text , 70.5, 92);
    }
}

const Nothing = (props) => {
    const {type} = props;
    let textType;

    if(type === 'HSPT') {
        textType = "검색된 병원이 없습니다.";
    }

    if(type === "HSPTTYPE") {
        textType = "등록된 진료과가 없습니다.";
    }

    if(type === "DOC") {
        textType = "신청가능한 서류가 없습니다."
    }
    return(
        <div className="nothing-box">
            <div>
                <img src={_icon_video_file} alt="" />
                <p style={{color:"#fff"}}>
                    {textType}
                </p>
            </div>
        </div>
    );
}